import React from 'react'
import AllRoutes from "./Components/AllRoutes"
import Header from './Components/Header'



const App = () => {
  return (
    <div>
      <Header />
      <AllRoutes />
    </div>
  )
}

export default App